import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import ConfirmModal from '../../../_common/Modal/ConfirmModal';
import { useState } from 'react';
import ArrowBackIosSharpIcon from '@mui/icons-material/ArrowBackIosSharp';
import { useTranslation } from 'react-i18next';

type FooterButtonProps = {
  onClickBack: () => void;
  onClickComplete: () => Promise<void>;
};

const FooterButton: React.FC<FooterButtonProps> = ({
  onClickBack,
  onClickComplete,
}) => {
  const { t } = useTranslation();

  /** 確認のダイアログが開いているか */
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);

  /** ダイアログのキャンセルボタン押下 */
  const handleCancel = () => {
    setIsOpenConfirmModal(false);
  };

  /** 完了のダイアログのOKボタン押下 */
  const handleComplete = async () => {
    setIsOpenConfirmModal(false);
    await onClickComplete();
  };

  return (
    <Box sx={{ flexGrow: 1, py: 2 }}>
      <Grid container spacing={2} justifyContent="space-between">
        <Grid size={2}>
          <Button
            variant="outlined"
            fullWidth
            sx={{ justifyContent: 'center' }}
            onClick={onClickBack}
            startIcon={
              <ArrowBackIosSharpIcon
                style={{
                  verticalAlign: 'middle',
                  fontSize: '16px',
                }}
              />
            }
          >
            {t('BTN_BACK')}
          </Button>
        </Grid>
        <Grid size={2}>
          <Button
            variant="contained"
            fullWidth
            sx={{ justifyContent: 'center' }}
            onClick={() => setIsOpenConfirmModal(true)}
          >
            {t('BTN_COMPLETE')}
          </Button>
        </Grid>
        <ConfirmModal
          isOpen={isOpenConfirmModal}
          displayMessage={{
            messageKey: 'MSG_COMPLETE',
            values: { 0: t('LBL_QC') },
          }}
          onClickCancel={handleCancel}
          onClickOk={handleComplete}
        />
      </Grid>
    </Box>
  );
};

export default FooterButton;
